<template>
    <li>
        <component
            :is="componentIs"
            :to="itemTo"
            :href="itemHref"
            :target="itemTarget"
            :class="isAsideMobile && item.img ? 'h-auto' : 'h-fit'"
            class="flex justify-between cursor-pointer border-b hover:bg-green-50"
            @click="menuClick"
        >
            <div v-if="isAsideMobile && item.img" class="w-full py-2">
                <img :src="item.img" alt="spo+shot banner" class="">
            </div>
            <div
                v-else
                class="w-full flex items-center justify-between"
            >
                <div class="flex items-center">
                    <icon
                        v-if="item.icon"
                        :path="item.icon"
                        class="mr-3"
                        :class="getColor(item.label)"
                        size="20"
                        h="h-full"
                    />
                    <spo-plus-top-icon
                        v-else
                        class="h-5 w-6 mt-2.5 mr-3"
                    />
                    <p
                        v-if="isAsideMobile"
                        class="px-2 text-xl text-gray-700 font-medium whitespace-pre-line"
                    >
                        {{ item.label=='ノート'?(sportType=='baseball'?'野球':'成長')+item.label:item.label }}
                    </p>
                </div>
                <icon
                    :path="mdiChevronRight"
                    class="text-[#B5B9C4] mr-3"
                    size="25"
                    h="h-full"
                />
            </div>
        </component>
        <div v-if="isAsideMobile && item?.submenu?.length && showSubmenuInfo.isShow">
            <div
                v-for="(menu, index) in item.submenu"
                :key="index"
            >
                <div
                    v-for="(subItems, categoryName) in menu"
                    :key="categoryName"
                    class="mx-2 mt-2 text-base"
                >
                    <p class="text-green-500 border-b border-green-500 mr-2 mb-2">
                        {{ categoryName }}
                    </p>
                    <li
                        v-for="sub in subItems"
                        :key="sub.to"
                        class="pt-1 pl-2"
                    >
                        <router-link
                            :to="sub.to"
                            :class="{'underline text-green-500': sub.to === path}"
                            class="text-gray-700 font-medium mt-4 hover:text-green-400 hover:cursor-pointer"
                            @click="$store.dispatch('asideMobileToggle')"
                        >
                            {{ sub.label }}
                        </router-link>
                    </li>
                </div>
            </div>
        </div>
    </li>
</template>

<script>
import SpoPlusTopIcon from "@/assets/img/SpoPlusTopIcon.vue"
import Icon from '@/spComponents/Utilities/Icon'
import {mdiChevronRight, mdiMinus} from '@mdi/js'
import {computed, defineAsyncComponent, ref} from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

export default {
    name: 'AsideMenuItem',
    components: {
        AsideMenuList: defineAsyncComponent(() => import('@/components/Utilities/AsideMenuList')),
        Icon,
        SpoPlusTopIcon
    },
    props: {
        item: {
            type: Object,
            default: () => {}
        },
        isSubmenuList: {
            type: Boolean,
            default: false
        },
        isAsideMobile: {
            type: Boolean,
            default: false
        },
        isGoSpoPlusHome: {
            type: Boolean,
            default: false
        },
        showSubmenuInfo: {
            type: Object,
            default: {
                isShow: true,
                label: 'ランキング'
            },
        },
    },
    emits: ['menu-click'],
    setup (props, { emit }) {
        const route = useRoute()
        const path = computed(() => route.path)
        const isDropdownActive = ref(false)
        const componentIs = computed(() => props.item.to ? 'router-link' : 'a')
        const hasDropdown = computed(() => !!props.item)
        const dropdownIcon = computed(() => isDropdownActive.value ? mdiMinus : mdiPlus)
        const itemTo = computed(() => props.item.to || null)
        const itemHref = computed(() => props.item.href || null)
        const itemTarget = computed(() => componentIs.value === 'a' && props.item.target ? props.item.target : null)
        const store = useStore()
        const sportType = computed(() => store.state.teamData.sport_type)

        const goSpoplus = () => {
            window.location.href = '/top/'
        }

        const menuClick = event => {
            // externalLinkがある場合は問答無用でそこに飛ばす
            if (props.item.externalLink) {
                window.open(props.item.externalLink, "_blank")
                return
            }

            if(props.isGoSpoPlusHome){
                goSpoplus()
                return
            }
            emit('menu-click', event, props.item)

            if (hasDropdown.value) {
                isDropdownActive.value = !isDropdownActive.value
            }
        }

        /* const styleActive = 'font-bold text-gray-900' */
        /* const styleInactive = 'text-gray-600' */
        const styleActive = 'font-bold text-white active-color'
        const styleInactive = 'font-medium inactive-custom-style'
        const styleInactiveIcon = 'inactive-icon-custom-style'

        const getColor = (type) => {
            switch (type) {
            case '利用ガイド':
                return 'text-[#3B82F6]'
            case 'ログアウト':
                return 'text-[#1E3A8A] '
            default:
                return 'text-[#00AF5B]'
            }
        }


        return {
            mdiChevronRight,
            path,
            isDropdownActive,
            componentIs,
            hasDropdown,
            dropdownIcon,
            itemTo,
            itemHref,
            itemTarget,
            menuClick,
            styleActive,
            styleInactive,
            styleInactiveIcon,
            getColor,
            sportType
        }
    }
}
</script>
